import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Badge, Button, Card } from "@vb/ui";
import { Seo } from "../lib/seo.js";
import { Section } from "../components/Section.js";
import { track } from "../lib/analytics.js";

export function PlayUnavailable() {
  useEffect(() => {
    track("play_unavailable_view", {});
  }, []);

  return (
    <>
      <Seo
        title="Demo unavailable · Vault Breaker Studios"
        description="The Vault Breaker public demo is not available in your region. We're a B2B game studio — contact sales if you operate a casino in a regulated market."
        path="/play/unavailable"
      />

      <Section>
        <Badge kind="bust" style={{ marginBottom: 18 }}>
          REGION RESTRICTED
        </Badge>
        <h1
          style={{
            fontFamily: "var(--font-display)",
            fontSize: "clamp(36px, 5vw, 56px)",
            lineHeight: 1.05,
            margin: 0,
            color: "var(--fg-1)",
            textTransform: "uppercase",
          }}
        >
          Demo not available in your region.
        </h1>
        <p
          style={{
            fontSize: 17,
            color: "var(--fg-2)",
            marginTop: 14,
            maxWidth: 720,
            lineHeight: 1.55,
          }}
        >
          This demo includes simulated betting mechanics and is not available in your
          jurisdiction. We're a B2B game studio — if you operate a casino in a regulated market,
          please get in touch.
        </p>
      </Section>

      <Section style={{ paddingTop: 0, maxWidth: 720 }}>
        <Card style={{ padding: 28, display: "grid", gap: 20 }}>
          <div style={{ display: "grid", gap: 10 }}>
            <span className="label" style={{ color: "var(--fg-3)" }}>
              For operators
            </span>
            <p style={{ margin: 0, fontSize: 14, color: "var(--fg-2)", lineHeight: 1.6 }}>
              Vault Breaker is a hosted game-server you embed in your existing casino. Pilots
              ship in about a week. Pricing is 10% revenue share — no platform fee, no minimums.
            </p>
          </div>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <Link to="/contact" style={{ textDecoration: "none" }}>
              <Button variant="gold" style={{ padding: "14px 22px", fontSize: 15 }}>
                CONTACT SALES →
              </Button>
            </Link>
            <Link to="/integration" style={{ textDecoration: "none" }}>
              <Button style={{ padding: "14px 22px", fontSize: 15 }}>
                READ INTEGRATION DOCS →
              </Button>
            </Link>
          </div>
          <div
            style={{
              marginTop: 4,
              paddingTop: 16,
              borderTop: "1px solid var(--line)",
              display: "grid",
              gap: 6,
            }}
          >
            <span
              style={{
                fontFamily: "var(--font-mono)",
                fontSize: 11,
                color: "var(--fg-3)",
                letterSpacing: "0.05em",
                textTransform: "uppercase",
              }}
            >
              18+ · play responsibly
            </span>
            <p
              style={{
                margin: 0,
                fontSize: 11,
                color: "var(--fg-3)",
                lineHeight: 1.6,
              }}
            >
              Gambling can be addictive. If you or someone you know is struggling, support is
              available — see{" "}
              <Link to="/responsible-gaming" style={{ color: "var(--cyan)" }}>
                /responsible-gaming
              </Link>{" "}
              for resources. Vault Breaker Studios builds B2B engines and does not operate a
              consumer-facing casino.
            </p>
          </div>
        </Card>
      </Section>
    </>
  );
}
